/**
 * @format
 * @description Extends standardArticle - ADV content article
 */
import mergeWith from "lodash/mergeWith";
import standardArticle from "./standard-article";
import { arrayMerge } from "utils/utils";

// Extends standardArticle (see below)
const advStandardArticle = {
  // available-slots-for-tier: {
  //   html: [],
  //   ldbd: [],
  //   boxr: [],
  //   halfpager: [],
  //   flex: [],
  //   flex2: [],
  //   flex3: [],
  //   btyb: [],
  // },
  mobile: {
    html: [[1, 1]],
    ldbd: [[1, 2]]
  },
  portrait: {
    html: [[1, 1]],
    ldbd: [[1, 2]]
  },
  landscape: {
    html: [[1, 1]],
    ldbd: [[1, 2]]
  },
  desktop: {
    html: [[1, 1]],
    ldbd: [[1, 2]]
  }
};

// Extend the long read article with premium article sizes
export default mergeWith(advStandardArticle, standardArticle, arrayMerge);
